/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useState, useEffect, useRef } from "react";
//#endregion
//#region Styles
import {
    CursorTime,
    EmptyActivityCard
} from "./styles";
//#endregion
//#region Utils
import {
    Container, Table, HourContent
} from "./styles";
import { getWeekDateRange } from "components/CustomDatePicker/utils/helpers";
import { isToday } from "utils/date";
import { getHours, getPositionForTimeCursor } from "./utils/helpers";
import { QUANTITY_PER_PAGE, WIDTH_HOUR_CONTENT } from "./utils/constants";
import ScheduleCellHeader from "./components/ScheduleCellHeader";
//#endregion

/*
@data 
{
    headers: [
        {
            render: //@type = Component
        }
    ],
    body: [
        // Objetos con estructura inyectada por el componente padre
    ]
}
*/
const Schedules = ({
    data, filterDate,
    takeWeek = false,
    renderActivity,
    startHour = 5
}) => {
    const $container = useRef();
    //#region States
    const [cursorTimePosition, setCursorTimePosition] = useState(0);
    const [tableWidth, setTableWidth] = useState(0);
    const [intervalId, setIntervalId] = useState(null);
    //#endregion
    //#region Effects
    const initTableWidthManager = () => {
        fillTableWidth();
        window.addEventListener("resize", fillTableWidth);
        return () => window.removeEventListener("resize", fillTableWidth);
    }
    const fillTableWidth = () => {
        setTableWidth($container.current.querySelector("table").clientWidth);
    };
    const scrollToTimeCursor = position => {
        $container.current.scrollTo({ top: position - 90, behavior: 'smooth' });
    }
    const initCursorTimePosition = () => {
        if (isTodayOrIsWeek() !== 0)
            return null;
        // Configurando comportamiento del cursor de tiempo para el horario
        const newCursorPosition = getPositionForTimeCursor(startHour);
        setCursorTimePosition(newCursorPosition);
        scrollToTimeCursor(newCursorPosition);
        const newIntervalId = setInterval(() => {
            setCursorTimePosition(getPositionForTimeCursor(startHour));
        }, 1000);
        return newIntervalId;
    };
    useEffect(initTableWidthManager, []);
    useEffect(() => {
        return () => clearInterval(intervalId);
    }, [intervalId]);
    useEffect(() => {
        if (data.headers.length > 0)
            fillTableWidth();
    }, [data.headers]);
    useEffect(() => {
        clearInterval(intervalId);
        const newIntervalId = initCursorTimePosition();
        setIntervalId(newIntervalId);
        return () => clearTimeout(newIntervalId);
    }, [filterDate]);
    //#endregion
    //#region Functions
    const getOffsetColumns = () => {
        const columnsQuantity = data.headers.length;
        return Array(QUANTITY_PER_PAGE - columnsQuantity).fill();
    }
    const renderHead = () => {
        return (
            <thead>
                <tr>
                    <th></th>
                    {data.headers
                        .map(({ render }, idx) => (
                            <ScheduleCellHeader key={idx}>
                                {render}
                            </ScheduleCellHeader>
                        ))
                        .concat(getOffsetColumns().map((_, idx) => (
                            <ScheduleCellHeader key={data.headers.length + idx}>
                                <h4 className="main-content"></h4>
                            </ScheduleCellHeader>
                        )))}
                </tr>
            </thead>
        );
    }
    const renderEmptyActivity = (idx, color, quantityCells = 4) => {
        const classList = ["empty-activity"];
        color && classList.push(color);
        return (
            <td key={idx} rowSpan={quantityCells}>
                <EmptyActivityCard
                    className={classList.join(" ")}
                    heightRatio={quantityCells} />
            </td>
        );
    }

    const isWeek = () => {
        if (filterDate === -1) return 0;
        const [monday, sunday] = getWeekDateRange(new Date());
        const mondayMillis = monday.getTime(),
            sundayMillis = sunday.getTime();
        // Verificando si la fecha del filtro está dentro de la semana de hoy
        if (filterDate >= mondayMillis && filterDate <= sundayMillis) return 0;
        return 1;
    }
    const isTodayOrIsWeek = () => {
        return takeWeek ? isWeek() : isToday(filterDate);
    }
    const renderBody = () => {
        return (
            <tbody>
                {getHours(startHour).map((time, idx) => {
                    return (
                        <tr key={idx}>
                            <td>
                                {time.minutes === 0 &&
                                    <HourContent>{(time.hour)}:00</HourContent>}
                            </td>
                            {data.body.map((item, idx) => {
                                return renderActivity({
                                    cell: { time, item, idx },
                                    helpers: {
                                        renderEmptyActivity
                                    }
                                });
                            })}
                        </tr>
                    );
                })}
            </tbody>
        );
    }
    //#endregion
    return (
        <>
            <Container ref={$container} className="custom-scrollbar secondary">
                {isTodayOrIsWeek() === 0 &&
                    <CursorTime
                        style={{
                            width: `calc(${tableWidth}px - ${WIDTH_HOUR_CONTENT})`,
                            top: `${cursorTimePosition}px`
                        }} />}
                <Table>
                    {renderHead()}
                    {renderBody()}
                </Table>
            </Container>
        </>
    );
}

export default Schedules;